import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashmixBox } from '../../../dsl/backoffice';
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactDataTabUI = class ContactDataTabUI extends Vue {
};
__decorate([
    Prop({ type: Array, required: true, default: () => [] })
], ContactDataTabUI.prototype, "items", void 0);
ContactDataTabUI = __decorate([
    Component({
        name: 'ContactDataTabUI',
        components: {
            // todo: remove dashmix from front module!
            DashmixBox
        },
        template: `
    <section>
      <div class="container">
        <div class="row">
          <div class="contact__data">
            <div v-for="item in items" :key="item.title" class="contact__data__card">
              <h5>{{ item.title }}</h5>
              <div v-html="item.description"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `
    })
], ContactDataTabUI);
export { ContactDataTabUI };
